import React from 'react'
import { Link } from 'react-router-dom';
const AddTitleBar = (props) => {
    return (
        <div id="dispatch_bar" style={{ overflow: 'visible' }}>
            <div className="container-fluid dip_bar">
                <div className="row">
                    <div className="col-sm-12">
                        <div className="d-flex justify-content-between">
                            <h2 className="page-title">{props.Title}</h2>
                            <form className="form-inline" action="#">
                                {!props.hideClose ?
                                    <Link to={props.LinkName} className="w3-button w3-hover-white w3-medium ml-1"><i className="fas fa-times"></i></Link>
                                    : ""}
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AddTitleBar
